import { useMemo } from 'react';
import { Outlet } from 'react-router-dom';

import { ThemeProvider } from '@mui/material/styles';

import createPublicDefaultTheme from 'themes/createPublicDefaultTheme';

export default function PublicLayout() {
  const publicTheme = useMemo(() => createPublicDefaultTheme(), []);

  return (
    <ThemeProvider theme={publicTheme}>
      <Outlet />
    </ThemeProvider>
  );
}
